import { CustomToastrAction, goToNextPage, toastr } from "@/imports-files/common/common";
import { JobCommon } from "@/imports-files/pages/career/view-job";
import { getJobListingData } from "@/imports-files/pages/clients/jobs/job";
import copy from 'copy-to-clipboard';
import router from "next/router";

export async function editJob(params)
{
    params.closeAllJobsOptions();
    var link         =   params.link.replace('$job_id', params.job_id);
    var key          =   'jobs';
    var setPageName  =   params.setPageName;
    var queryClient  =   params.queryClient;
    var link         =   params.link.replace('$job_id', params.job_id);
    var result       =   await new JobCommon().editJob(params.job_id);
    params.setApiError(result.response);

    if( result.data.is_editable || result.data.is_editable == undefined || params.router.query.job_type == 'draft' )
    {
        params.router.push(link);
    }
    else
    {
        params.setjobEditModal(['Open', link]);
    }

}

export async function copyJob(params)
{
    params.closeAllJobsOptions();
    var duplicateJob =   await new JobCommon().duplicateJob(params.job_id);
    var link         =   params.link.replace('$job_id', duplicateJob.data.id);
    // var key          =   'jobs';
    // var setPageName  =   params.setPageName;
    // var queryClient  =   params.queryClient;
    // goToNextPage(key, setPageName, queryClient, link);
    params.router.push(link);
}


export async function duplicateJob(params)
{ 
    params.from == "kanban" ? '' : params?.closeAllJobsOptions();
    var duplicateJob = await new JobCommon().duplicateJob(params.job_id);
    var link         =   params.link.replace('$job_id', duplicateJob.data.id);
    // var key          =   'jobs';
    // var setPageName  =   params.setPageName;
    // var queryClient  =   params.queryClient;
    // goToNextPage(key, setPageName, queryClient, link);
    params.router.push(link)
}

export function promoteJob(params)
{
    params.closeAllJobsOptions();
    var link         =   params.link.replace('$job_id', params.job_id);
    // var key          =   'jobs';
    // var setPageName  =   params.setPageName;
    // var queryClient  =   params.queryClient;
    // goToNextPage(key, setPageName, queryClient, link);
    params.router.push(link)
}

export function copyJobUrl(params)
{
    params.closeAllJobsOptions();
    var link      =   params.link.replace('$slug', params.slug);
    link          =   link.replace('$client_slug', params.client_slug);
    var proptocol =   window.location.protocol;
    var host_arr  =   window.location.host.split('.');
    host_arr[0]   =   'jobs';
    var new_host  =   host_arr.join('.');
    link = proptocol+'//'+new_host+link;
    copy(link);
}

export async function closeJob(params)
{
    var param_list   =    params.router.query;
    params.closeAllJobsOptions();
    var body = { 'job': {'close_job': true } };
    await new JobCommon().closeJob(body, params.job_id);
    await params.setJobCloseModal({state: false})
    var result  = await new getJobListingData(param_list, params.setApiError);
    params.setJobList(result.data);  
}

export async function publishJob(params)
{
    var param_list               =   params.router.query;
    const customToastrAction     =   new CustomToastrAction();
    params.closeAllJobsOptions();
    const publish_result         =   await new JobCommon().publishJob(params.job_id);
    if(publish_result.data?.success) customToastrAction.setNormalToastr(publish_result.data.success, 'success'); 
    // toastr.success(publish_result.data.success)
    var result  =  await getJobListingData(param_list, params.setApiError);
    params.setJobList(result.data);  
    
}

export async function deleteJob(params)
{
    var param_list               =    params.router.query;
    const customToastrAction     =   new CustomToastrAction();
    params.closeAllJobsOptions();
    const destroy_result = await new JobCommon().destroyJob(params.job_id);
    if(destroy_result.data?.success) customToastrAction.setNormalToastr(destroy_result.data.success, 'success')  
    // toastr.success(destroy_result.data.success)
    var result  =  await getJobListingData(param_list, params.setApiError);
    params.setJobList(result.data);  
}

export function performJobAction(ActionName, params)
{
    switch(ActionName)
    {
        case 'edit_job':
                        editJob(params);
                        break;
        case 'duplicate_job':
                        duplicateJob(params);
                        break;
        case 'promote':
                        promoteJob(params);
                        break;
        case 'copy_job_url':
                        copyJobUrl(params);
                        break;
        case 'close_job':
                        // closeJob(params);
                        params.setJobCloseModal({state: true, params: params})
                        break;
        case 'publish_job':
                        publishJob(params);
                        break;
        case 'delete_job':
                        deleteJob(params);
                        break;
        case 'copy_job':
                        copyJob(params);
                        break;
        default: '';
    }  
}

export function isPreviousUpdateBeforeTwoDays(days_data)
{
    var isConditionValid = false;
    if(days_data != '' && days_data != undefined && days_data != null)
    {   
        if(days_data.includes("days ago"))
        {
            var days_data = days_data.split('');
            isConditionValid = parseInt(days_data[0]) >= 2;
        }
    }
    return isConditionValid;
}
